import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {NavigationStart, Router, RouterLink, RouterLinkActive} from "@angular/router";
import {isPlatformBrowser, NgIf} from "@angular/common";

@Component({
  selector: 'app-menu',
  standalone: true,
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.less'],
  imports: [RouterLink, RouterLinkActive, NgIf]
})
export class MenuComponent implements OnInit {
  scrolled: boolean = true;
  show: boolean = false;

  constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {
  }

  toggleMenu() {
    this.show = !this.show;
    if (isPlatformBrowser(this.platformId)) {
      document.body.style.overflow = this.show ? 'hidden' : 'auto';
    }
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.show = false;
        if (isPlatformBrowser(this.platformId)) {
          document.body.style.overflow = 'auto';
        }
      }
    })
  }

}
